module.exports = __webpack_public_path__ + "assets/7337410acfc7582553c51924eaf57a71.png";